import { zetApi } from '@zet/network'

export const genreateDownloadReportCSV = async ({
  start_date,
  end_date,
  report_type = 'EARNINGS',
  is_my_teams_req,
}: {
  start_date?: string
  end_date?: string
  report_type: string
  is_my_teams_req: boolean
}) => {
  const { data } = await zetApi.get('/v1/report/generate', {
    params: {
      start_date,
      end_date,
      report_type,
      is_my_teams_req: is_my_teams_req,
    },
  })
  return data?.data
}
